import bindAllMethods from '../../utils/bindAllMethods';
import { ITenantHandlerService } from '../../services/tenantHandler';
import { AuthContextEnum } from '../../services/authTokenService';
import { INavigationService } from '../../services/navigationService';
import { LOGIN_AND_LOGGEDOUT_PATH_LIST } from '../../services/session/constants';
import { ISessionService } from '../../services/session';

type AdvanceRequestsProps = {
  tenantHandlerService: ITenantHandlerService;
  navigationService: INavigationService;
  sessionService: ISessionService;
};

export default class AdvanceRequests {
  private _tenantHandlerService: ITenantHandlerService;
  private _navigationService: INavigationService;
  private _sessionService: ISessionService;

  constructor({
    tenantHandlerService,
    navigationService,
    sessionService
  }: AdvanceRequestsProps) {
    this._tenantHandlerService = tenantHandlerService;
    this._navigationService = navigationService;
    this._sessionService = sessionService;
    bindAllMethods(this);
  }

  private async advanceGetTenantListPromise() {
    const currentPath = this._navigationService.location.pathname;
    if (!LOGIN_AND_LOGGEDOUT_PATH_LIST.includes(currentPath)) {
      void this._tenantHandlerService.getTenantList({
        authContext: AuthContextEnum.tenant,
        refreshList: true
      });
    }
  }

  async init(): Promise<void> {
    //TODO check if need to verify this information inside of getTenandList function
    if (
      this._sessionService.isLoggedIn() &&
      this._tenantHandlerService.isEnabled()
    ) {
      void this.advanceGetTenantListPromise();
    }
  }
}
